import { useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  CircularProgress,
} from '@mui/material';
import { AccountBalance, Save, Cancel } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import ClientBankAccountBasicInfoSection from './ClientBankAccountBasicInfoSection';
import FormErrorSummary from '@/components/FormErrorSummary/FormErrorSummary';

const ClientBankAccountFormDialog = ({
  open,
  onClose,
  organizationId,
  onSave,
  loading = false,
  fieldErrors = {},
  generalErrors = [],
}) => {
  const { t } = useTranslation();
  const basicInfoRef = useRef(null);

  const handleSave = () => {
    if (basicInfoRef.current) {
      onSave(basicInfoRef.current.formData);
    }
  };

  const isFormDisabled = loading;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='md'
      fullWidth
      PaperProps={{
        sx: { minHeight: '70vh' },
      }}>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AccountBalance color='primary' />
          {t('clientBankAccounts.createTitle')}
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ pt: 3 }}>
          <FormErrorSummary errors={generalErrors} />
          <ClientBankAccountBasicInfoSection
            ref={basicInfoRef}
            organizationId={organizationId}
            fieldErrors={fieldErrors}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 3 }}>
        <Button onClick={onClose} startIcon={<Cancel />}>
          {t('clientBankAccounts.cancel')}
        </Button>
        <Button
          onClick={handleSave}
          variant='contained'
          startIcon={
            loading ? (
              <CircularProgress size={20} sx={{ color: 'white' }} />
            ) : (
              <Save sx={{ color: 'white' }} />
            )
          }
          disabled={isFormDisabled}
          sx={{
            color: 'white',
            '& .MuiButton-startIcon': {
              color: 'white',
            },
          }}>
          {loading
            ? t('clientBankAccounts.saving')
            : t('clientBankAccounts.create')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClientBankAccountFormDialog;
